export default __webpack_public_path__ + "ce3fadd11ae288aef84fd67499162c8f.svg";